import axios from "axios";

export default axios.create({
  baseURL: `https://j66d85vpbf.execute-api.ap-south-1.amazonaws.com/student`,
});
//
// http://localhost:8083
